export default "__VITE_ASSET__BUs3rLry__"